module.exports = __webpack_public_path__ + "img/other_pay_samsungpay.b5c0ab9f.svg";